import React from "react";

import { Activity } from "app/userManagement/modules/generic";

const OperatorActivity = () => {
  return (
    <>
      <Activity />
    </>
  );
};

export default OperatorActivity;
